"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WORKER_URLS = exports.NOTIFICATION_TYPES = exports.LOGGED_STATUS = exports.WORKER_TYPES = void 0;
exports.WORKER_TYPES = {
    NOTIFICATION: "NOTIFICATION",
    PRUEBA: "PRUEBA",
};
exports.LOGGED_STATUS = {
    LOGGED: "logged",
    SOFTLOGGED: "softlogged",
    PUBLIC: "public",
};
exports.NOTIFICATION_TYPES = {
    COMMERTIAL: "commertial",
    BREAKDOWN: "breakdown",
    USAGES: "usages",
    BILLS: "bills",
    TRACKING: "tracking",
};
exports.WORKER_URLS = {
    PROD: "https://www.movistar.es/ps5/sw/workers/notification.worker.worker.js",
    QA: "https://www.movistar.es/qa/sw/workers/notification.worker.worker.js",
};
//# sourceMappingURL=constants.js.map